import { useState } from "react";

export const useToast = () => {
  const [toast, setToast] = useState<{
    open: boolean;
    message: string;
    color: "success" | "danger";
  }>({
    open: false,
    message: "",
    color: "success",
  });

  const handleCloseToast = () => {
    setToast((prev) => ({ ...prev, open: false }));
  };

  const showSuccessToast = (message: string) => {
    setToast({
      open: true,
      message,
      color: "success",
    });
  };

  const showErrorToast = (message: string) => {
    setToast({
      open: true,
      message,
      color: "danger",
    });
  };

  return {
    toast,
    handleCloseToast,
    showSuccessToast,
    showErrorToast,
  };
};